<widget-header
  [name]="widgetName"
  [editable]="isEditable">

  <attribute-help-text slot="prepend"
    attribute="members"
  [attributeScope]="'Project'" />

  <widget-menu slot="menu"
    [resource]="resource" />
</widget-header>

<div class="op-widget-box--body">
  @if (noMembers) {
    <op-no-results [title]="text.noResults" />
  }
  <div class="op-members-widget--attributes-map -minimal-keys">
    @for (usersByRole of usersByRole; track usersByRole) {
      <div class="attributes-map--key">
        {{usersByRole.role.name}}
      </div>
      <div class="attributes-map--value">
        @for (principal of usersByRole.users; track principal; let last = $last) {
          <op-principal [principal]="principal"
            size="mini"
           />
          @if (!last) {
            ,
          }
        }
      </div>
    }
  </div>
  @if (moreMembers) {
    <div
      class="op-members-widget--notification">
      {{moreMembersText}}
    </div>
  }
  <div class="op-members-widget--grid--widget-footer">
    @if (membersAddable$ | async) {
      <a
        [href]="projectMembershipsPath + '?show_add_members=true'"
        class="button -primary">
        <i class="button--icon icon-add" aria-hidden="true"></i>
        <span class="button--text"
          [textContent]="text.add">
        </span>
      </a>
    }

    @if (!noMembers) {
      <a
        [href]="projectMembershipsPath"
        class="button -highlight-inverted">
        <i class="button--icon icon-group" aria-hidden="true"></i>
        <span class="button--text"
          [textContent]="text.viewAll">
        </span>
      </a>
    }
  </div>
</div>
